/**
 * Replace em/en dashes with ASCII hyphen (-) in storefront copy (all pages).
 */
(function () {
  var DASH_RE = /[\u2013\u2014\u2015]/g;
  var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1 };

  function shouldSkipNode(node) {
    var parent = node.parentElement;
    while (parent) {
      if (SKIP_TAGS[parent.tagName]) return true;
      parent = parent.parentElement;
    }
    return false;
  }

  function normalizeTextNode(node) {
    var text = node.nodeValue;
    if (!text || !DASH_RE.test(text)) return;
    node.nodeValue = text.replace(DASH_RE, '-');
  }

  function normalizeRoot(root) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        return shouldSkipNode(node) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
      },
    });
    var node;
    while ((node = walker.nextNode())) {
      normalizeTextNode(node);
    }
  }

  function run() {
    normalizeRoot(document.body);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('codeskin:collection-swapped', run);
  document.addEventListener('shopify:section:load', run);
})();
